import React from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../common/permissions";

const PermissionRoute = ({ module, action = "view", children }) => {
  const allowed = hasPermission(module, action);

  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
    // or "/access-denied"
  }

  return children;
};

export default PermissionRoute;
